import React, { useEffect, useState } from "react";

import { useSelector, useDispatch, shallowEqual } from "react-redux";

import { Dimmer, Loader, Segment, Icon } from "semantic-ui-react";

import Outcome from "ModularQuestions/Outcome";
import ValuesBuilder from "ModularQuestions/ValuesBuilder";

import {
  UPDATE_BRIEF_RESPONSE,
  SG_UPDATE_BRIEF_RESPONSE,
} from "constants/actions";
import { SwitchTransition, CSSTransition } from "react-transition-group";
import { TRANSITIONSPEED, SlideDirection } from "constants/animation";

const ModularQuestion = ({
  id,
  setModularComplete,
  token,
  briefResponseId,
  setEnableNavigation,
  language,
}) => {
  const dispatch = useDispatch();

  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [currentQuestion, setCurrentQuestion] = useState(false);

  const [allQuestions, setAllQuestions] = useState([]);
  const [answers, setAnswers] = useState({});


  const { get_brief_response, get_modular_questions } = useSelector(
    (state) => ({
      get_brief_response: state.briefresponse,
      get_modular_questions: state.questions,
    }),
    shallowEqual
  );

  // Extract feedback_builder questions
  useEffect(() => {
    const _totalQuestions = [];
   
    if (
      get_modular_questions?.modular_questions?.feedback_builder?.questions?.[0]
        ?.questions
    ) {
      get_modular_questions.modular_questions.feedback_builder.questions[0].questions.forEach(
        (q) => _totalQuestions.push({ question_type: "feedback_builder", ...q })
      );
    }
    if (
        get_modular_questions?.modular_questions?.outcome_question?.questions?.[0]
          ?.questions
      ) {
        get_modular_questions.modular_questions.outcome_question.questions[0].questions.forEach(
          (q) => _totalQuestions.push({ question_type: "outcome_question", ...q })
        );
      }
    setAllQuestions(_totalQuestions);

  }, [get_modular_questions]);

  useEffect(() => {
    if (allQuestions?.length > 0) {
      setCurrentQuestion(allQuestions[currentQuestionIndex]);
    }
  }, [
    currentQuestionIndex,
    allQuestions,
    setModularComplete,
    setEnableNavigation,
  ]);

  const saveAnswer = (currentresponse) => {
    const _answers = { ...answers }; // Create a shallow copy of answers

    // Initialize the nested objects if they don't exist
    if (!_answers[currentresponse?.question_type]) {
      _answers[currentresponse?.question_type] = {};
    }

    // Assign currentresponse to the appropriate question type and id
    _answers[currentresponse?.question_type][currentresponse?.id] =
      currentresponse;

    setAnswers(_answers);

    if (currentQuestionIndex + 1 > allQuestions?.length - 1) {
      MarkCurrentComplete();
      setModularComplete(true);
      setEnableNavigation(true);
    }

    setCurrentQuestionIndex(currentQuestionIndex + 1);
  };

//   // console.log(allQuestions)
//   console.log("answers", answers);
//   console.log("allQuestions", allQuestions);

  function MarkCurrentComplete() {

    const payload = {
      visual_question: get_brief_response?.visual_question,
      current_question: get_brief_response?.current_question,
      current_answer: get_brief_response?.current_answer,
      high_answer: get_brief_response?.high_answer,
      answers: get_brief_response?.answers,
      complete: get_brief_response?.complete,
      intro_completed: get_brief_response?.intro_completed,
      intro2_completed: get_brief_response?.intro2_completed,
      validation_token: get_brief_response?.validation_token,
      feedback: get_brief_response?.feedback,
      survey_personality: get_brief_response?.survey_personality,
      in_survey_personality: get_brief_response?.in_survey_personality,
      modular_response: answers,
    };
    dispatch({
      type: UPDATE_BRIEF_RESPONSE,
      payload,
    });

    // persist with api
    if (briefResponseId) {
      dispatch({
        type: SG_UPDATE_BRIEF_RESPONSE,
        payload: {
          id: briefResponseId,
          stored_response: payload,
          query: `?token=${token}`,
          validation_token: get_brief_response?.validation_token,
        },
      });
    }
  }

  return (
    <SwitchTransition>
      <CSSTransition
        key={currentQuestion?.question_type || 0}
        timeout={TRANSITIONSPEED}
        classNames={SlideDirection[1]}
      >
        {!currentQuestion ? (
          <>
            <Icon loading name="spinner" />
          </>
        ) : (
          <>
            {currentQuestion?.question_type === "outcome_question" && (
              <Outcome
                currentQuestion={currentQuestion}
                saveAnswer={saveAnswer}
              />
            )}

            {(currentQuestion?.question_type === "values_builder") |
              (currentQuestion?.question_type === "feedback_builder") && (
              <ValuesBuilder
                currentQuestion={currentQuestion}
                saveAnswer={saveAnswer}
                language={language}
              />
            )}
          </>
        )}
      </CSSTransition>
    </SwitchTransition>
  );
};

export default ModularQuestion;
